import { render, staticRenderFns } from "./PredefinedStatus.vue?vue&type=template&id=2af0cabf&scoped=true&"
import script from "./PredefinedStatus.vue?vue&type=script&lang=js&"
export * from "./PredefinedStatus.vue?vue&type=script&lang=js&"
import style0 from "./PredefinedStatus.vue?vue&type=style&index=0&id=2af0cabf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2af0cabf",
  null
  
)

export default component.exports